import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useAppDispatch} from 'src/redux/storeHooks';
import useAppToast from 'src/hooks/useAppToast';
import {setForgetPasswordToken} from 'src/redux/slices/authSlice';

const VerifyAccountActivation = () => {
  const {activation_token} = useParams<{activation_token: string}>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {warningToast} = useAppToast();

  useEffect(() => {
    if (!activation_token) {
      warningToast('Invalid or missing token.');
      navigate('/auth/login-page');
      return;
    }

    dispatch(setForgetPasswordToken({token: activation_token}));
    navigate('/auth/start-role-user-account-activation');
  }, [dispatch, activation_token, navigate, warningToast]);

  return null;
};

export default VerifyAccountActivation;
